import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!

  return (_ctx.options)
    ? (_openBlock(), _createBlock(_component_van_checkbox_group, {
        key: 0,
        modelValue: _ctx.checkedVal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedVal) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_cell, {
              key: item.value,
              title: item.label,
              class: _normalizeClass({ active: _ctx.checkedVal.includes(item.value) }),
              clickable: "",
              onClick: ($event: any) => (_ctx.toggle(index))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_van_checkbox, {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  name: item.value,
                  ref_for: true,
                  ref: el => (_ctx.checkboxRefs[index] = el),
                  style: {"margin-right":"10px"}
                }, null, 8, ["name"])
              ]),
              _: 2
            }, 1032, ["title", "class", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}